import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid } from '@mui/material';
import {
  deleteCar,
  getCar,
  getFacilities,
  patchUpdateCar,
  postAddCar,
} from 'redux/actions/UserCar';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import CommonTable from 'components/commonTable/CommonTable';
import CommonDialog from 'components/commonDialog/CommonDialog';
import Loader from 'components/loader/Loader';
import CommonButton from 'components/commonButton/CommonButton';
import { cabDetails } from './DataAddCab';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';
import { vehicelPriority } from 'utils/enumObj';

function AddCabView() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [carData, setCarData] = useState({});
  const [type, setType] = useState('Create');
  const [defaultValue, setDefaultValue] = useState({});
  const [selectedImage, setSelectedImage] = useState('');
  const carList = useSelector((state) => state?.userCar?.userCar?.data);
  const vehicleLoader = useSelector((state) => state?.userCar?.loading);
  const faciliesList = useSelector(
    (state) => state?.userFacilities?.userFacilities?.data
  );

  useEffect(() => {
    dispatch(getCar({loader:true}));
    dispatch(getFacilities());
  }, []);

  const breadcrumbPaths = [
    { name: 'Vehicle Category', url: '', className: 'colorPrimary' },
  ];

  const onClickMoreIcon = (data, typeVal) => {
    setCarData(data);
    if (typeVal === 'Delete') {
      const val = {
        carId: data.id,
      };
      dispatch(deleteCar(val));
    } else if (typeVal === 'Activate') {
      const val = {
        status: 'Active',
        carId: data.id,
      };
      dispatch(patchUpdateCar(val));
    } else if (typeVal === 'Deactivate') {
      const val = {
        status: 'InActive',
        carId: data.id,
      };
      dispatch(patchUpdateCar(val));
    } else {
      const value = {
        category: data?.carType,
        customerSeat: data?.seater,
        facilities: data?.Facilities,
        avtar: data?.avtar,
        priority: data?.priority,
        description: data?.description,
      };
      setDefaultValue(value);
      setType(typeVal);
      setOpen(true);
    }
  };
  const onImageHandleChange = (data) => {
    setSelectedImage(data);
  };
  const payloadData = (data, type) => {
    let facilitiesData = data?.facilities?.map((list) => list.id)
    let formData = new FormData();
    formData.append('carType', data?.category);
    formData.append('AC', true);
    formData.append('avtar', selectedImage);
    formData.append('seater', data?.customerSeat);
    formData.append('priority', data?.priority);
    formData.append('description', data?.description || '');
    if (type?.toLowerCase() === 'edit') {
      formData.append('carId', carData?.id);
    }
    if (Array.isArray(data?.facilities)) {
    facilitiesData?.forEach(facilityId => {
        formData.append('facilityIds[]', facilityId);
    });
  }
    return formData;
  };

  const editPayloadData = (data, type) => {
    let formData = new FormData();
  
    if (data?.category !== carData?.carType) {
      formData.append("carType", data?.category);
    }
    formData.append("AC",true);
    formData.append("carId",carData?.id)
    if (data?.customerSeat !== carData?.seater) {
      formData.append("seater", data?.customerSeat);
    }
  
    if (data?.avtar !== carData?.avtar) {
      formData.append("avtar", selectedImage);
    }
  
    if (data?.priority !== carData?.priority) {
      formData.append("priority", data?.priority);
    }
  
    if (Array.isArray(data?.facilities)) {
      data?.facilities?.forEach(facilityId => {
        formData.append("facilityIds[]", facilityId?.id);
      });
    }

    if (data?.description !== carData?.description) {
      formData.append("description", data?.description);
    }
  
    return formData;
  };
  const onDialog = (data, code) => {
    if (type?.toLowerCase() === 'edit') {
      dispatch(patchUpdateCar(editPayloadData(data, type)));
    } else {
      dispatch(postAddCar(payloadData(data)));
    }
    setOpen(false);
  };

  const handleOpenDialog = () => {
    setType('Create');
    setOpen(true);
    setDefaultValue({});
  };

   //roles and permissions
   const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions
  );
  const configRoleEnum =
    roleAndPermissionEnum.configuration;

  const accessForall = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { defaultAllAccess: configRoleEnum?.subModules?.vehicleCategory?.all }
  );

  const accessForEdit = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { customAccess: configRoleEnum?.subModules?.vehicleCategory?.edit }
  );

  const accessForAdd = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { customAccess: configRoleEnum?.subModules?.vehicleCategory?.add }
  );
  const hasViewMoreIcon = (accessForall || accessForEdit);

  const addAccess = (accessForall || accessForAdd)

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="marginBlock10"
      >
        <Grid item>
          <CommonBreadCrumb paths={breadcrumbPaths} />
        </Grid>
        <Grid item>
          <CommonButton
            name={addAccess && 'Vehicle Category +'}
            btnClass={'btnMedium btnYellow'}
            iconPlace="back"
            onClick={() => {
              handleOpenDialog();
            }}
          />
        </Grid>
      </Grid>
      {vehicleLoader ? (
        <Loader />
      ) : (
        <CommonTable
          data={carList}
          onClickMoreIcon={onClickMoreIcon}
          tabName={'cabCategory'}
          isClickable={false}
          viewMoreIcon={!hasViewMoreIcon}
        />
      )}

      {open ? (
        <CommonDialog
          className="marginbottom20"
          open={open}
          handleClose={() => setOpen(false)}
          formData={cabDetails(carData,vehicelPriority)}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          selectType={type?.toLowerCase() === 'edit' ? 'edit' : 'Create'}
          type={
            type?.toLowerCase() === 'edit'
              ? 'Edit Vehicle Category '
              : 'Vehicle Category'
          }
          defaultValues={defaultValue}
          optionData={faciliesList}
          onImageHandleChange={onImageHandleChange}
        />
      ) : null}
    </div>
  );
}

export default AddCabView;
